module.exports = __webpack_public_path__ + "img/MONA.5f30a55e.svg";